import { environment } from '../environments/environment.dev';
export const API_URL = 'https://rbqhsebe.rbdemo.live';
// export const API_URL = 'http://localhost:8000';



// WEBPACK FOOTER //
// /app/src/app/config.ts